import Glide, {
    Controls,
    Swipe,
    Keyboard,
    Images,
} from '@glidejs/glide/dist/glide.modular.esm.js'

export default class Slider {
    constructor(el) {
        const glide = new Glide(el, {
            animationDuration: 0,
            perTouch: 1,
            perView: 1,
            rewindDuration: 0,
            type: 'carousel',
        })
        glide.mount({ Controls, Swipe, Keyboard, Images })
    }
}
